exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scoped--special-collapse[data-v-0257b5cb]{width:50px}.scoped--special-collapse>.special-collapse-text[data-v-0257b5cb]{text-orientation:upright;writing-mode:vertical-lr;margin-top:.5rem}.scoped-general-settings[data-v-0257b5cb]{position:relative;min-width:30%}.scoped-general-settings.collapsed[data-v-0257b5cb]{min-width:0;width:75px}.scope-general-setting-block[data-v-0257b5cb]{margin:1rem .1rem}.scope-set-min-height[data-v-0257b5cb]{min-height:280px}", ""]);

// exports
